const API_VERSION = '2.0';
const BAIDU_CALLBACK = 'baiduloadedcallback';
const BAIDU_MARKER_URL = 'http://api.map.baidu.com/marker';

export { API_VERSION, BAIDU_CALLBACK, BAIDU_MARKER_URL };
